<template>
    <v-row>
        <v-col cols="12" lg="5" order-lg="2">
            <v-img data-aos="fade" data-aos-duration="800" :max-height="$vuetify.breakpoint.lgAndUp ? '' : '240'" src="/images/sub/firm/firm-img.jpg" alt="" class="firm-image" />
        </v-col>
        <v-col cols="12" lg="7" order-lg="1">
            <v-sheet color="transparent" max-width="648" height="100%" class="d-flex flex-column justify-space-between" data-aos="fade-right" data-aos-duration="700">
                <div class="txt break-keep">
                    <template v-if="lang === 'ko'">
                        <p>
                            세이지(SAGE)라는 이름에는 ‘지혜롭고 신뢰할 수 있는 동반자’로서, <br class="d-none d-lg-block" />
                            끊임없는 변화와 도전 속에서도 깊은 통찰과 전문성을 바탕으로 고객의 가치를 지키겠다는 저희의 다짐이 담겨 있습니다.
                        </p>
                        <br />
                        <p>세이지는 기업자문과 M&A, 그리고 국내외 소송 등 분쟁 해결 분야에 특화된 법무법인입니다. 저희는 모든 법률 분야를 다 잘할 수는 없다는 사실을 잘 알고 있습니다. 그러나 저희가 잘하는 분야에서는, 누구보다 깊이 있게 고민하고, 누구보다 정교하게 실행함으로써 고객들로부터 최고의 실력과 로열티를 인정받고 있습니다.</p>
                        <br />
                        <p>
                            저희는 파트너 변호사들이 직접 실무를 이끄는 효율적인 팀 구성(lean team)을 통해 <br class="d-none d-lg-block" />
                            불필요한 비용을 줄이고, 현실적인 해법을 제시하는 실용적 조언(practical solution), <br class="d-none d-lg-block" />
                            그리고 고객이 진정으로 원하는 결과(desired result)에 도달하는 것을 핵심 가치로 삼아 꾸준히 실천해 왔습니다.
                        </p>
                        <br />
                        <p>저희에게 주저없이 연락 주시면 최고의 실력과 정성으로 보답하겠습니다.</p>
                    </template>
                    <template v-else>
                        <p>The name <strong>SAGE</strong> embodies our commitment to serving as a “wise and trustworthy companion.” Guided by insight and expertise, we are dedicated to safeguarding our clients’ value in an environment of constant change and challenge.</p>
                        <br />
                        <p>SAGE specializes in M&A/corporate advisory and domestic/international dispute resolution. We know that no firm can claim strength in all areas of law, but in the fields where we do excel, we are recognized for our depth of analysis, precision of execution, and the trust and loyalty we earn from our clients through exceptional results.</p>
                        <br />
                        <p>Our lean teams, led directly by partners, allow us to minimize unnecessary costs while staying focused on what matters most: delivering practical solutions, providing clear and actionable advice, and achieving the results most desired by our clients.</p>
                    </template>
                </div>
                <img src="/images/sub/firm/firm-logo.svg" alt="" class="d-block mt-40px" />
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        lang: { type: String, default: "ko" },
    },
};
</script>

<style lang="scss" scoped>
.firm-image {
    position: relative;
    overflow: visible;
    &::after {
        content: "";
        position: absolute;
        top: -12px;
        right: -12px;
        width: 100%;
        height: 100%;
        border: 1px solid black;
    }
}
@media (min-width: 1024px) {
    .v-image {
        &::after {
            top: -40px;
            right: -40px;
        }
    }
}
</style>
